var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('div',{staticClass:"error-404"},[_c('h1',[_vm._v("Error 404: Seite nicht gefunden")]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Zurück zur Startseite")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }